import { render, staticRenderFns } from "./info-tag.component.vue?vue&type=template&id=0553dc9a"
import script from "./info-tag.component.ts?vue&type=script&lang=ts&external"
export * from "./info-tag.component.ts?vue&type=script&lang=ts&external"
import style0 from "./info-tag.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports